import * as colors from "src/styles/constants/colors";
import styled from "styled-components";

export const ContactsContainer = styled.div`
  grid-column: 2 / span 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  padding: 5px 16px 16px 24px;
  background: ${colors.brightLight};
  overflow: hidden;
`;

export const HeadingWrapper = styled.div`
  margin-left: 12px;
  margin-top: 12px;
  display: flex;
  align-items: center;
`;
